<template>
  <div>
    <b-form @submit.prevent>
      <b-row>

        <!-- first name -->
        <b-col cols="12">
          <b-form-group
            label="Book ID"
            label-for="vi-id"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="BookIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-id"
                v-model="book.id"
                placeholder="Book Id"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group
            label="Download URL"
            label-for="vi-url"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="LinkIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-url"
                v-model="book.url"
                placeholder="Book Download URL"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group
            label="Detail URL"
            label-for="vi-details-url"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="LinkIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-details-url"
                v-model="book.bookDetailsURL"
                placeholder="Book Details HTML URL"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group
            label="Free Path"
            label-for="vi-free-path"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="LinkIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-free-path"
                v-model="book.freePath"
                placeholder="Book free path"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group
            label="IapBookId"
            label-for="vi-iapBookId"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="LinkIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-iapBookId"
                v-model="book.iapBookId"
                placeholder="Book iapBookId"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group
            label="Icon"
            label-for="vi-path"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="LinkIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-icon"
                v-model="book.icon"
                placeholder="Book icon"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group
            label="Status"
            label-for="vi-status"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="EditIcon" />
              </b-input-group-prepend>
              <b-form-select
                id="vi-status"
                v-model="book.status"
                :options="statuses"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group
            label="Password"
            label-for="vi-password"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="KeyIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-password"
                v-model="book.password"
                placeholder="Password"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <!-- checkbox -->
        <b-col cols="12">
          <b-form-group>
            <b-form-checkbox
              id="checkbox-4"
              v-model="book.puzzle"
              name="checkbox-4"
              value="true"
            >
              Puzzle
            </b-form-checkbox>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group
            label="Upload Date"
            label-for="vi-upload-date"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="LinkIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-upload-date"
                v-model="book.dateUploaded"
                placeholder="Upload Date ( format: dd/mm/yyyy )"
              />
            </b-input-group>
          </b-form-group>
        </b-col>

        <!-- reset and submit -->
        <b-col cols="12">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
            @click="saveBook"
          >
            Save
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import axios from 'axios'
import firebase from 'firebase/app'
import 'firebase/auth'
import {
  BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton, BInputGroup, BInputGroupPrepend, BFormSelect,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BFormSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      book: {},
      statuses: [
        { value: 'NORMAL', text: 'NORMAL' },
        { value: 'WEBSPECIAL', text: 'WEBSPECIAL' },
        { value: 'HIDDEN', text: 'HIDDEN' },
        { value: 'DELETED', text: 'DELETED' },
      ],
    }
  },
  mounted() {
  },
  methods: {
    saveBook() {
      const url = `${this.$readerURL}/admin/books`
      this.loader('block')
      firebase.auth().currentUser.getIdToken(false).then(idToken => {
        axios.post(url, this.book,
          {
            headers: {
              Authorization: idToken,
            },
          }).then(response => {
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'success',
              icon: 'EditIcon',
              variant: 'success',
            },
          })

          this.$router.push('/books')
          return response
        }).catch(error => {
          this.loader('none')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error,
              icon: 'EditIcon',
              variant: 'error',
            },
          })
        })
      })
    },
  },
}
</script>
